import { render, staticRenderFns } from "./VideoConferencing.vue?vue&type=template&id=0c6553fe&"
import script from "./VideoConferencing.vue?vue&type=script&lang=js&"
export * from "./VideoConferencing.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports